/**
 * Справочник городов платформы: GET /admin/refs/cities (id + name).
 * Фильтр «Город» показывает имена, а бэку уезжают id — маппинг имён
 * в id делает getClients через этот же кэш. Мок-режим — города из мока.
 */

import {apiEnabled, http} from '@services/utils';

import {MOCK_CLIENTS} from '../mocks';

export type CityRef = {id: string; name: string};

const asObj = (v: unknown): Record<string, unknown> =>
  (typeof v === 'object' && v !== null ? v : {}) as Record<string, unknown>;

/** Кэш на сессию: справочник статичный, дёргать гейтвей на каждый фильтр незачем */
let cache: Promise<CityRef[]> | null = null;

export const getCities = (): Promise<CityRef[]> => {
  if (!apiEnabled) {
    const names = [...new Set(MOCK_CLIENTS.map((c) => c.cityName))].sort();
    return Promise.resolve(names.map((name) => ({id: name, name})));
  }
  cache ??= http<unknown[]>('admin/refs/cities', {skipCaseConversion: true})
    .then((list) =>
      (Array.isArray(list) ? list : []).map((raw) => {
        const r = asObj(raw);
        return {
          id: typeof r.id === 'string' ? r.id : '',
          name: typeof r.name === 'string' ? r.name : '',
        };
      }),
    )
    .catch((e: unknown) => {
      cache = null; // не залипаем на ошибке — следующий вызов попробует снова
      throw e;
    });
  return cache;
};
